require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-foundations-i-location-announcement.json") })
        }
      }, "path---blog-foundations-i-location-announcement");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-foundations-i-location-announcement!./.cache/json/blog-foundations-i-location-announcement.json
// module id = 822
// module chunks = 231608221292675